/* eslint-disable */
import i18n from '../../../i18n/i18n'
export default {
  pages: {
    key: "title",
    data: [
      // DASHBOARDS
      { title: i18n.t('sidebar.Apiaries'), url: "/apiaries", icon: "HexagonIcon", is_bookmarked: false },
      { title: i18n.t('sidebar.Hives'), url: "/hives", icon: "ArchiveIcon", is_bookmarked: false },
      { title: i18n.t('sidebar.Warnings'), url: "/alarms", icon: "BellIcon", is_bookmarked: false },
      { title: i18n.t('sidebar.Rules'), url: "/rules", icon: "ListIcon", is_bookmarked: false },

      // PAGES
      { title: i18n.t('login.Title'), url: "/login", icon: "LockIcon", is_bookmarked: false },
      { title: i18n.t('register.Title'), url: "/register", icon: "UserPlusIcon", is_bookmarked: false },
      { title: i18n.t('login.ForgotPassword'), url: "/forgot-password", icon: "HelpCircleIcon", is_bookmarked: false },
      { title: i18n.t('login.reset.ResetPassword'), url: "/reset-password", icon: "UnlockIcon", is_bookmarked: false },
      { title: i18n.t('errors.404.Title'), url: "/not-found", icon: "MonitorIcon", is_bookmarked: false },
    ]
  }
}
/* eslint-enable */
